export enum BaseSelectStatementId {
	MapData = 56,

	EsoNetworkDeepDiveProductDetails = 10000,
	EsoNetworkDeepDiveCaptions = 10002,
	EsoNetworkDeepDiveMultipleProductDetails = 10005,

	DEV_ESOSupplyForecastOverviewTable = 10003,
	CapacityOverviewMatrix = 10004,

	OrderOptimizerOrderLineData = 10006,
	OrderOptimizerOrderData = 10008,
	OrderOptimizerSupplierData = 10009,
	OrderOptimizerMasterData = 10097,
	OrderStatusData = 10012,

	DEV_GetSelectionSets = 10013,

	ForecastActivitiesGridData = 10014,
	ForecastActivityListItemsGridData = 10117,

	DEV_GetCapacityOverviewChartData = 10015,
	EsoStockProjection = 10016,

	DEV_GetProjectTasksGridData = 10022,
	DEV_GetProjectDeepDiveGridData = 10091,

	DEV_GetEsoSimulateMultiGridData = 10090,

	DEV_GetFiltersPriority = 10057,
	DEV_GetSeriesTypes = 10063,

	DEV_GetListOfColorGroups = 10029,
	DEV_GetColorGroupColors = 10035,

	DEV_GetNavbarNavigationItems = 10064,

	DEV_GetBookmarks = 10065,
	DEV_GetBookmarkElements = 10066,

	DEV_GetRoutes = 10077,

	DEV_GetMRPOverviewFiltersData = 10092,

	DEV_GetForecastActivitiesListsGridData = 10093,
	DEV_GetOrderOptimizerOverView = 10094,

	DEV_StockControllingHeatMapFilterValues=10098,
	DEV_StockControllingOverviewDynamicData=10099,
	DEV_StockControllingIssueDevelopmentFilter=10100,
	EsoOverviewGridData=10010,
	ForecastActivitiesResultsGridData=10011,
	DEV_GetForecastOverviewFilters=10101,
	Dev_GetForecastOverviewFiltersStatistical=10109,
	DEV_GetForecastValidationLogFilters = 10110,
	EsoOverviewStockValueChart = 10107,
	EsoOverviewChangeCountChart = 10108,
	StockControllingDeepDive =10104,
	StockControllingHeatMap=10111,
	StockControllingEsoDeepDiveIssues=10113,
	CapacityDeepDiveInfo=10115,
	CapacityDeepDiveTreeList=10116,
	TaskList=10114,
	ListElements=10118,
	HelpCategories=10119,
	StockControllingIssueDevelopmentByProduct=10112,
	ManualInput=10120,
	ForecastActivitiesResultsChartData=10121,
	EsoDeepDiveGridData=10122,		
	StatisticalForecastOverviewTableData=10123,
	StatisticalForecastDeepDiveTableData=10124,
	ForecastOverviewTableData=10125,
	ESOSupplyForecastOverviewTable=10127,
	StockControllingIssueDevelopmentChart=10128,
	IssueResponses=10129,
	ForecastDeepDive=10130,
	ForecastDeepDiveMaster=10131,
	ESOStockProjectionGridData=10132,
	ForecastActivitiesListsGridData=10134
	
}
